import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';

const InletDamper = ({ control, tableView }) => {    
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Inlet Damper</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.inletDamperQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.inletDamperType'
                type='text'
                control={control}
                label='Type'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.inletDamperMaterial'
                type='text'
                control={control}
                label='Material'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.inletDamperBlades'
                type='text'
                control={control}
                label='Blades'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.inletDamperNoBlades'
                type='text'
                control={control}
                label='No. of blades'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.inletDamperBearings'
                type='text'
                control={control}
                label='Bearings'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.inletDamperControl'
                type='text'
                control={control}
                label='Control'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.inletDamperNotes'
                type='textarea'
                control={control}
                label='Notes'
                style={{width: '24%', marginRight: '1%'}}
                InputProps={{
                    multiline:true
                }}
            />
        </>   
    );
};

export default InletDamper;
